import axios from "axios";
import {
  CREATED_TRAVELER_PROFILE,
  IPerson,
  TravelerProfileProperties,
  UPDATED_TRAVELER_PROFILE,
} from "redmond";

import { airBookingApi } from "@b2bportal/air-booking-api";
import {
  getTravelerProfileTrackingProperties,
  isCorpTenant,
  replaceObjectValues,
} from "@capone/common";
import { ToggleActions } from "halifax";
import { trackEvent } from "../../analytics/trackEvent";
import { config } from "../../../config";

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const {
        isNewTraveler,
        setIsMyProfile,
        hideProfileAction,
        entryPoint,
        person,
        previousPerson,
        ...payload
      } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await airBookingApi(
        axios as any
      ).apiV0FlightPassengersUpdatePut({
        ...payload,
        person: cleanPersonPayload,
      });

      const responseBody: IUpdateUserPassengerResponse = res.data;
      resolve(responseBody);

      if (isCorpTenant(config.TENANT)) {
        trackEvent({
          eventName: isNewTraveler
            ? CREATED_TRAVELER_PROFILE
            : UPDATED_TRAVELER_PROFILE,
          properties: {
            ...getTravelerProfileTrackingProperties({
              person: body.person,
              previousPerson,
            }),
            source: body.source,
            private: hideProfileAction === ToggleActions.ON,
            entry_point: "checkout",
          } satisfies TravelerProfileProperties,
        });
      }
    } catch (e) {
      reject(e);
    }
  });

export interface IUpdateUserPassengerRequest {
  person: IPerson;
  isNewTraveler?: boolean;
  previousPerson?: IPerson;
  source?: string;
  setIsMyProfile?: boolean;
  hideProfileAction?: ToggleActions;
  entryPoint?: string;
}

export interface IUpdateUserPassengerResponse {}
